const unavailablePreviewLabels = {
  cs: 'Náhled není dostupný',
  en: 'Preview is unavailable',
  sk: 'Náhľad nie je dostupný',
} as const;

export function getUnavailablePreviewLabel(locale: string): string {
  return (
    unavailablePreviewLabels[locale as keyof typeof unavailablePreviewLabels] ??
    unavailablePreviewLabels.en
  );
}

/** Display order only; the model and API keep their original named dimensions. */
export function formatPreviewDimensions(
  { heightMm, widthMm, depthMm }: { heightMm: number; widthMm: number; depthMm: number },
  locale: string,
): string {
  const labels = locale === 'cs' || locale === 'sk' ? ['V', 'Š', 'H'] : ['H', 'W', 'D'];
  return `${labels[0]} ${heightMm} × ${labels[1]} ${widthMm} × ${labels[2]} ${depthMm} mm`;
}
